import { FetchNewSupportCallProps, IDnResponse, IGetIPagedSelectProps, IPagedSelectResponse } from "../models/newSupportCall";
import ApiService from "../services/api";

export const createNewSupportCallFetch = async (body: FetchNewSupportCallProps): Promise<any> => {
  const apiService = new ApiService(import.meta.env.VITE_API_URL, 'api/v1/tas');
	const url = `/tas-occurrences`;

  try {
    const response = await apiService.post<any>(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

		return response.data;

  } catch (error) {
    console.error("Erro ao criar nova solicitação:", error);
    return null;
  }
};

export const fetchSupportRegionals = async ({ page, size }: IGetIPagedSelectProps): Promise<IPagedSelectResponse | null> => {
    const apiService = new ApiService(import.meta.env.VITE_API_URL, 'api/v1/tas');

    const url = `/support/regionals?page=${page}&size=${size}`;

    try {
      const response = await apiService.get<any>(url);
      
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
}

export const fetchSupportOccurrenceOrigins = async ({ page, size }: IGetIPagedSelectProps): Promise<IPagedSelectResponse | null> => {
    const apiService = new ApiService(import.meta.env.VITE_API_URL, 'api/v1/tas');

    const url = `/support/occurrence-origins?page=${page}&size=${size}`;

    try {
      const response = await apiService.get<any>(url);
      
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
}

export const fetchDnsOptions = async (): Promise<IDnResponse[] | null> => {
    const apiService = new ApiService();

    const url = `dealerships/consultant-group`;

    try {
      const response = await apiService.get<any>(url);
      
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
}

export const fetchAllDnsBySearch = async (name: string): Promise<IDnResponse[] | null> => {
    const apiService = new ApiService();

    const url = `dealerships?name=${name}`;

    try {
      const response = await apiService.get<any>(url);
      
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
}


